import type { CompanyRecord } from "./types";

/** Transcribed from the "Über HAINTZ IT-SOLUTIONS" block of the former literal prompt. */
export const COMPANY: CompanyRecord = {
  legalName: "HAINTZ IT-SOLUTIONS",
  founder: "Ing. Martin Haintz",
  location: {
    de: "Graz, Steiermark, Österreich",
    en: "Graz, Styria, Austria",
  },
  email: "office@haintz.dev",
  phone: "+43 681 20 42 2019",
  website: "haintz.dev",
  audience: {
    de: "österreichische KMUs und Enterprise-Kunden im B2B-Umfeld",
    en: "Austrian SMEs and enterprise clients in a B2B context",
  },
  /**
   * Framed as one point of contact rather than as a job title.
   *
   * "Lead Developer und Architekt" described the role; what a customer is
   * actually buying is that the person in the first conversation is still the
   * person at the handover. That is the promise, so it is the one stated.
   */
  usp: {
    de: "Ein einziger Ansprechpartner über das gesamte Projekt: Ing. Martin Haintz, der Gründer des Unternehmens. Er führt das Erstgespräch, verantwortet Architektur und Umsetzung und begleitet die Übergabe. Sie werden nicht an einen Account-Manager oder wechselnde Ansprechpartner weitergereicht.",
    en: "One single point of contact for the whole project: Ing. Martin Haintz, the company's founder. He runs the first conversation, owns the architecture and the implementation, and sees the handover through. You are never passed on to an account manager or to changing contacts.",
  },
};

/**
 * Fills the `{email}` and `{phone}` placeholders in a translation string.
 *
 * The catalogues carry no copy of either value, so a message that names them
 * cannot disagree with this record.
 */
export function withContactDetails(text: string): string {
  return text
    .replaceAll("{email}", COMPANY.email)
    .replaceAll("{phone}", COMPANY.phone);
}
